import { Injectable } from "@angular/core";

import { HttpService, HttpServiceBaseCRUD, GetPagedBody } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class CouponsService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "coupons/";
  }

  add(body: any) {
    return this.post<any>({ APIName: "add", body, showAlert: true });
  }

  update(body: any) {
    return this.put<any>({ APIName: "update", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete<boolean>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    return this.get<any>({ APIName: `get-id/${id}` });
  }

  getPaged(body: GetPagedBody<any>) {
    return this.getPagedRequest<any[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<any[]>({ APIName: "getall" });
  }

  getCouponDiscount(body: any) {
    return this.post<any>({ APIName: "getcoupondiscount", body, showAlert: false });
  }
}
